const breakpoints = {};

export default breakpoints;
